
export const style: any = {
    theme: {
        sizes: {
            sm: {
                width: '16px',
                height: '16px'
            },
            md: {
                width: '24px',
                height: '24px'
            },
            lg: {
                width: '32px',
                height: '32px'
            },
            xg: {
                width: '48px',
                height: '48px'
            }
        }
    }
}